import { appInitialState, AppState } from './states/app.state';
import { userInitialState, UserState } from './states/user.state';
import { homeInitialState, HomeState } from '@store/states/home.state';
import { masterInitialState, MasterState } from '@store/states/master.state';
import { recentInputInitialState, RecentInputState } from '@store/states/recent-input.state';
import { notificationsInitialState, NotificationsState } from './states/notifications.state';
import { authInitialState, AuthState } from '@store/states/auth.state';
import { consumptionInitialState, ConsumptionState } from '@store/states/consumption.state';
import { consumptionInvoicesInitialState, ConsumptionInvoicesState } from '@store/states/consumption-invoices.state';
import { alertsInitialState, AlertsState } from '@store/states/alerts.state';
import { sustainabilityInitialState, SustainabilityState } from './states/sustainability.state';
import { languageInitialState, LanguageState } from '@store/states/language.state';
import { proceduresListingInitialState, ProceduresListingState } from '@store/states/procedures-listing.state';
import { myInvoicesInitialState, MyInvoicesState } from '@store/states/my-invoices.state';
import { myServicesInitialState, MyServicesState } from '@store/states/my-services.state';
import { spendingTrendsInitialState, SpendingTrendsState } from '@store/states/spending-trends.state';

export type StoreState = {
  alerts: AlertsState;
  app: AppState;
  auth: AuthState;
  consumption: ConsumptionState;
  consumptionInvoices: ConsumptionInvoicesState;
  home: HomeState;
  language: LanguageState;
  master: MasterState;
  myServices: MyServicesState;
  myInvoices: MyInvoicesState;
  notifications: NotificationsState;
  proceduresListing: ProceduresListingState;
  recentInput: RecentInputState;
  sustainability: SustainabilityState;
  user: UserState;
  spendingTrends: SpendingTrendsState;
};

export const storeInitialState: StoreState = {
  alerts: alertsInitialState,
  app: appInitialState,
  auth: authInitialState,
  consumption: consumptionInitialState,
  consumptionInvoices: consumptionInvoicesInitialState,
  home: homeInitialState,
  language: languageInitialState,
  master: masterInitialState,
  myServices: myServicesInitialState,
  myInvoices: myInvoicesInitialState,
  notifications: notificationsInitialState,
  proceduresListing: proceduresListingInitialState,
  recentInput: recentInputInitialState,
  sustainability: sustainabilityInitialState,
  user: userInitialState,
  spendingTrends: spendingTrendsInitialState,
};
